export default __webpack_public_path__ + "static/media/home.f6c1d456dcec75b8f77742c2825fdb5a.svg";